/// <reference types="./checkmark.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function checkmark() {
  return $svg.square(
    24,
    "<path fill=\"currentColor\" d=\"M9.99999 15.172L19.192 5.979L20.607 7.393L9.99999 18L3.63599 11.636L5.04999 10.222L9.99999 15.172Z\"/>",
  );
}
